// extracted by mini-css-extract-plugin
module.exports = {"root":"_1xBzm","bg":"_3NuDC"};